
import { Box, Divider, Grid, Typography, Tooltip, IconButton, Autocomplete, FormControl, Select, TextField, InputAdornment, Tabs, useTheme, FormGroup, FormControlLabel, Checkbox, Button, Toolbar, MenuItem, createFilterOptions, Avatar } from "@mui/material";
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import { Business, EmailOutlined, } from '@mui/icons-material';
import React, { useState, useEffect } from "react";
import PhoneIcon from '@mui/icons-material/Phone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import Email from '@mui/icons-material/EmailOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { Switch } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Save from '@mui/icons-material/SaveAltOutlined';
import Cancel from '@mui/icons-material/CancelOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import ContactTable from "../../../components/Person-contact-table";
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import CustomAutocomplete from "../../../pages/commancomponents/customAutoComplete";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CallAlertBar from "../../../Layout/Alertbar";

import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import useBankAccountType from "../../../hooks/useBankAccountType";

import useSelectedOption from "../../../components/useSelectedOption";
import AddBankAccount from "../../master/AddBankAccount";
import AddPartyType from "../../master/AddPartyType";
import BankDetailsForm from "../../common/BankDetails";
import AddTDS from "../../master/AddNewTDS";
import AddPaymentTerms from "../../master/AddPaymentTerms";
import AddCreditTerms from "../../master/AddNewCreditTerms";


const filter = createFilterOptions();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}






const AddNewVendor = ({ handlecallback, editPartyID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = React.useState(0);


  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  // hook call
  const { bankAccounts, loadBankAccountByID, } = useBankAccountType(0);

  const salutationOptions = [
    { Description: 'Mr' },
    { Description: 'Mrs' },
    { Description: 'Ms' },
    { Description: 'Miss' },
    { Description: 'Dr' }
  ];
  // multiple selection options

  const [creditTerms, setCreditTerms] = useState([]);
  const [creditTermAnchorEl, setCreditTermAnchorEl] = useState(null);
  const [selectedCreditTerm, setSelectedCreditTerm] = useState(null);
  const [creditTermFilterText, setCreditTermFilterText] = useState('');
  const [isCreditTermsLoaded, setIsCreditTermsLoaded] = useState(false);

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
  const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);
  const [customerNotes, setCustomerNotes] = useState('');

  const [creditLimitRules, setCreditLimitRules] = useState([]);
  const [creditLimitRuleAnchorEl, setCreditLimitRuleAnchorEl] = useState(null);
  const [selectedCreditLimitRule, setSelectedCreditLimitRule] = useState(null);
  const [creditLimitRuleFilterText, setCreditLimitRuleFilterText] = useState('');
  const [isCreditLimitRuleLoaded, setIsCreditLimitRuleLoaded] = useState(false);

  const [currency, setCurrency] = useState([]);
  const [currencyAnchorEl, setCurrencyAnchorEl] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencyFilterText, setCurrencyFilterText] = useState('');
  const [isCurrencyLoaded, setIsCurrencyLoaded] = useState(false);


  const [tds, setTDS] = useState([]);
  const [tdsAnchorEl, setTDSAnchorEl] = useState(null);
  const [selectedTDS, setSelectedTDS] = useState(null);
  const [tdsFilterText, setTDSFilterText] = useState('');
  const [isTDSLoaded, setIsTDSLoaded] = useState(false);


  const [country, setCountry] = useState([]);
  const [countryID, setCountryID] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);

  const [isCountryLoaded, setIsCountryLoaded] = useState(false);


  const [state, setState] = useState([]);
  const [stateID, setStateID] = useState([]);

  const [selectedState, setSelectedState] = useState(null);

  const [city, setCity] = useState([]);
  const [cityID, setCityID] = useState([]);

  const [selectedCity, setSelectedCity] = useState(null);



  const [billingCountry, setBillingCountry] = useState([]);
  const [billingCountryID, setBillingCountryID] = useState([]);

  const [selectedBillingCountry, setSelectedBillingCountry] = useState(null);

  const [isBillingCountryLoaded, setIsBillingCountryLoaded] = useState(false);



  const [billingState, setBillingState] = useState([]);
  const [billingStateID, setBillingStateID] = useState([]);
  const [selectedBillingState, setSelectedBillingState] = useState(null);

  const [billingCity, setBillingCity] = useState([]);
  const [billingCityID, setBillingCityID] = useState([]);
  const [selectedBillingCity, setSelectedBillingCity] = useState(null);

  // billing fields
  const [billingAddressLine1, setBillingAddressLine1] = useState('');
  const [shippingAddressLine1, setShipingAddressLine1] = useState('');
  const [pincode, setPincode] = useState('');
  const [shippingPincode, setShippingPincode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumber2, setPhoneNumber2] = useState('');
  const [shippingPhoneNumber, setShippingPhoneNumber] = useState('');
  const [shippingPhoneNumber2, setShippingPhoneNumber2] = useState('');
  const [faxNumber, setFaxNumber] = useState('');
  const [shippingfaxNumber, setShippingFaxNumber] = useState('');
  const [billingarea, setBillingArea] = useState('');
  const [billingcontactperson, setBillingContactPerson] = useState('');
  const [shippingcontactperson, setShippingContactPerson] = useState('');
  const [correspondencecontactperson, setCorrespondenceContactPerson] = useState('');
  const [shippingarea, setShippingArea] = useState('');
  const [email2, setEmail2] = useState('');

  // correspondence fields
  const [correspondencePincode, setCorrespondencePincode] = useState('');
  const [correspondenceAddressLine1, setCorrespondenceAddressLine1] = useState('');
  const [selectedCorrespondenceCountry, setSelectedCorrespondenceCountry] = useState(null);
  const [correspondenceCountryID, setCorrespondenceCountryID] = useState([]);
  const [correspondenceState, setCorrespondenceState] = useState([]);
  const [correspondenceCity, setCorrespondenceCity] = useState([]);
  const [correspondenceCountry, setCorrespondenceCountry] = useState([]);
  const [isCorrespondenceCountryLoaded, setIsCorrespondenceCountryLoaded] = useState(false);
  const [correspondanceStateID, setCorrespondanceStateID] = useState([]);
  const [selectedCorrespondanceState, setSelectedCorrespondanceState] = useState(null);
  const [selectedCorrespondenceCity, setSelectedCorrespondenceCity] = useState(null);
  const [correspondenceCityID, setCorrespondenceCityID] = useState([]);
  const [correspondenceArea, setCorrespondenceArea] = useState('');
  const [correspondancePhoneNumber, setCorrespondancePhoneNumber] = useState('');
  const [correspondancePhoneNumber2, setCorrespondancePhoneNumber2] = useState('');
  const [correspondanceEmail1, setCorrespondanceEmail1] = useState('');
  const [correspondanceEmail2, setCorrespondanceEmail2] = useState('');

  const [shippingEmail2, setShippingEmail2] = useState('');
  // details
  const [salutation, setSalutation] = useState(
    salutationOptions.find(o => o.Description === 'Mr')
  );
  const [selectedSalutation, setSelectedSalutation] = useState('Mr');


  const [firstName, setFirstName] = useState('');
  const [secondName, setSecondName] = useState('');
  const [partyID, setPartyID] = useState(0);
  const [companyName, setCompanyName] = useState('');
  const [partyDisplayName, setPartyDisplayName] = useState('');
  const [isDisplayNameEdited, setIsDisplayNameEdited] = useState(false);

  const [partyEmail, setPartyEmail] = useState('');
  const [partyWorkPhone, setPartyWorkPhone] = useState('');
  const [partyMobile, setPartyMobile] = useState('');
  const [partyGST_Number, setPartyGST_Number] = useState('');
  const [partyPAN_Number, setPartyPAN_Number] = useState('');
  const [partyMSME_Register, setPartyMSME_Register] = useState(false);
  const [partyMSME_Number, setPartyMSME_Number] = useState('');
  const [currencyID, setCurrencyID] = useState(0);
  const [paymentTermsID, setPaymentTermsID] = useState(0);
  const [creditTermsID, setCreditTermsID] = useState(0);
  const [creditTermsRulesID, setCreditTermsRulesID] = useState(0);
  const [tdsID, setTDSID] = useState(0);
  const [unit, setUnit] = useState('');
  const [contacts, setContacts] = useState([]);
  const [fysalevalue, setFysalevalue] = useState(0.00);

  // load party type 
  const [partyType, setPartyType] = useState([]);
  const [selectedPartyType, setSelectedPartyType] = useState(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);

  const [gstFile, setGstFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [msmeFile, setMSMEFile] = useState(null);

  const [panFileBase64, setPanFileBase64] = useState(null);
  const [gstFileBase64, setGstFileBase64] = useState(null);
  const [msmeFileBase64, setMSMEFileBase64] = useState(null);

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  const isPanValid = panRegex.test(partyPAN_Number) || partyPAN_Number === '';

  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const isGSTValid = gstRegex.test(partyGST_Number) || partyGST_Number === '';






  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isCreditTermsModalOpen, setIsCreditTermsModalOpen] = useState(false);

  const [updateProgress, setUpdateProgress] = useState(true);
  const [isUpdateProgress, setIsUpdateProgress] = useState(false);
  const [accountMismatch, setAccountMismatch] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState('Active');
  const [partyList, setPartyList] = useState([]);
  const [selectedPartyID, setSelectedPartyID] = useState(0);
  const [selectedParty, setSelectedParty] = useState(null);

  const [checkedTcsApplicable, setCheckedTcsApplicable] = useState(false);
  const handleChangeTcsApplicable = (event, isChecked) => {
    setCheckedTcsApplicable(isChecked); // note: second arg is the boolean
  };

  useEffect(() => {
    if (!isDisplayNameEdited) {
      setPartyDisplayName(companyName);
    }
  }, [companyName, isDisplayNameEdited]);


  const handleCompanyNameChange = (e) => {
  const value = e.target.value.toUpperCase();
  setCompanyName(value);

  if (!isDisplayNameEdited) {
    setPartyDisplayName(value);
  }
};

const handleDisplayNameChange = (e) => {
  setPartyDisplayName(e.target.value.toUpperCase());
  setIsDisplayNameEdited(true);
};


  useEffect(() => {
    if (!isDataLoaded) {

      const para = {
        p_companyid: 1,
      }

      callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setPartyList(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
  }, [isDataLoaded]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault(); // Prevents focusing on the button when clicked
  };


  useEffect(() => {
    if (!isUpdateProgress) {
      if (editPartyID === 0) {
        setUpdateProgress(false);
      }
    }

  }, [editPartyID])



  const handlePanFileChange = (file) => {
    //const file = e.target.files[0];
    setPanFile(file.name);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]; // Remove "data:*/*;base64,"
      setPanFileBase64(base64String);
    };
  };

  const handleGSTFileChange = (file) => {
    //const file = e.target.files[0];
    setGstFile(file.name);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]; // Remove "data:*/*;base64,"
      setGstFileBase64(base64String);
    };
  };


  const handleMSMEFileChange = (file) => {
    //const file = e.target.files[0];
    setMSMEFile(file.name);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1]; // Remove "data:*/*;base64,"
      setMSMEFileBase64(base64String);
    };
  };




  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };


  const callback = () => {
    handlecallback();

  }
  const [isModalAccountOpen, setIsModalAccountOpen] = useState(false);

  const [isModalPartyTypeOpen, setIsModalPartyTypeOpen] = useState(false);


  const handleOpenModal = () => {
    setIsModalAccountOpen(true);
  };

  const handleOpenModalPartyType = () => {
    setIsModalPartyTypeOpen(true);
  };

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });


  const [bankDetails, setBankDetails] = useState([{
    accountHolderName: '',
    bankName: '',
    accountNumber: '',
    reEnterAccountNumber: '',
    ifsc: '',
    accountTypeId: '',
    branchName: '',
    bankAddress: '',
    contactNumber: '',
    cancelledCheque: null,
    cancelledCheque_file_name: '',
    rtgsDetail: null,
    rtgsDetail_file_name: '',
    bankLetter: null,
    bankLetter_file_name: '',
    id_document: 0,
    document_type: '',
    bank_id_val: 0,
  }]);

  const [shippingAddress, setShippingAddress] = useState([{
    shippingAddressLine1: '',
    pincode: '',
    country: '',
    state: '',
    city: '',
    contact: '',
    email: '',
    fax: '',
    countryId: 0,
    stateId: 0,
    cityId: 0,
  }]);

  const handleShippingInputChange = (index, e) => {
    const { name, value } = e.target;
    const newShippingAddress = [...shippingAddress];
    newShippingAddress[index][name] = value;
    setShippingAddress(newShippingAddress);
  };

  const removeShippingDetail = (index) => {
    const newShippingAddress = shippingAddress.filter((_, i) => i !== index);
    setShippingAddress(newShippingAddress);
  };

  const addShippingDetail = () => {
    setShippingAddress([...shippingAddress, {
      shippingAddressLine1: '',
      pincode: '',
      country: '',
      state: '',
      city: '',
      contact: '',
      email: '',
      fax: '',
      countryId: 0,
      stateId: 0,
      cityId: 0,
    }]);
  };



  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const newBankDetails = [...bankDetails];
    newBankDetails[index][name] = value;
    setBankDetails(newBankDetails);
  };

  const handleChequeInputChange = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const newBankDetails = [...bankDetails];
    newBankDetails[index]['cancelledCheque'] = file;
    newBankDetails[index]['cancelledCheque_file_name'] = file.name;
    setBankDetails(newBankDetails);
  };

  const handleRTGSInputChange = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const newBankDetails = [...bankDetails];
    newBankDetails[index]['rtgsDetail'] = file;
    newBankDetails[index]['rtgsDetail_file_name'] = file.name;
    setBankDetails(newBankDetails);
  };

  const handleBankLetterInputChange = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const newBankDetails = [...bankDetails];
    newBankDetails[index]['bankLetter'] = file;
    newBankDetails[index]['bankLetter_file_name'] = file.name;
    setBankDetails(newBankDetails);
  };

  const handleDownloadBankLetter = (index, e, docType) => {
    try {

      const bank = [...bankDetails];

      let rawData = null;
      let fileName = '';

      if (docType === 'bank_letter') {
        rawData = bank[index]?.bankLetter;
        fileName = bank[index]?.bankLetter_file_name || 'bank_letter.pdf';
      }
      else if (docType === 'rtgs') {
        rawData = bank[index]?.rtgsDetail;
        fileName = bank[index]?.rtgsDetail_file_name || 'rtgs.pdf';
      }
      else if (docType === 'cancel_cheque') {
        rawData = bank[index]?.cancelledCheque;
        fileName = bank[index]?.cancelledCheque_file_name || 'cancelled_cheque.pdf';
      }

      if (!rawData) {
        alert("No file found.");
        return;
      }

      let byteArray;

      if (rawData.startsWith('\\x')) {
        // Hex format (\xNN\xNN...)
        const hexString = rawData.replace(/\\x/g, '');
        const hexPairs = hexString.match(/.{1,2}/g); // Split into byte pairs
        if (!hexPairs) throw new Error("Invalid hex format");

        const byteNumbers = hexPairs.map(h => parseInt(h, 16));
        byteArray = new Uint8Array(byteNumbers);
      } else {
        // Assume it's base64
        try {
          const byteCharacters = atob(rawData);
          const byteNumbers = new Array(byteCharacters.length)
            .fill()
            .map((_, i) => byteCharacters.charCodeAt(i));
          byteArray = new Uint8Array(byteNumbers);
        } catch (base64Err) {
          throw new Error("Invalid base64 format");
        }
      }

      // Download logic
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    } catch (error) {
      console.error("Download error:", error);
      alert("An error occurred while downloading the file.");
    }
  };



  const addBankDetail = () => {
    if (accountMismatch) {
      alert("Fix account number mismatch before continuing");
      return; // 🚫 stops further processing
    }


    setBankDetails([...bankDetails, {
      accountHolderName: '',
      bankName: '',
      accountNumber: '',
      reEnterAccountNumber: '',
      ifsc: '',
      accountTypeId: '',
      branchName: '',
      bankAddress: '',
      contactNumber: '',
      cancelledCheque: null,
      cancelledCheque_file_name: '',
      rtgsDetail: null,
      rtgsDetail_file_name: '',
      bankLetter: null,
      bankLetter_file_name: '',
      id_document: 0,
      document_type: '',
      bank_id_val: 0,
    }]);
  };

  const handleAutocompleteChange = (index, field, value) => {
    const updatedDetails = [...bankDetails];
    updatedDetails[index][field] = value;
    setBankDetails(updatedDetails);
  };


  const removeBankDetail = (index) => {
    const newBankDetails = bankDetails.filter((_, i) => i !== index);
    setBankDetails(newBankDetails);
  };



  useEffect(() => {
    if (!isCurrencyLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_CURRENCY_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setCurrency(data);
            // setSelectedCurrency(data[0]);

            // setSelectedCurrency(
            //   data.find(item => item.description === 'INR- Rupees') || null
            // );



          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isCurrencyLoaded]);


  useEffect(() => {
    if (!isCreditTermsLoaded) {
      fetchCreditTerms();
    }
  }, [isCreditTermsLoaded]);


  const fetchCreditTerms = async () => {
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_mode: 1,
    }
    callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_CREDIT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setCreditTerms(data);
          // setSelectedCreditTerm(data[0]);

        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  }

  useEffect(() => {
    if (!isPaymentTermsLoaded) {
      fetchPaymentTerms();
    }
  }, [isPaymentTermsLoaded]);


  const fetchPaymentTerms = async () => {
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_mode: 1,
    }
    callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setPaymentTerms(data);
          // setSelectedPaymentTerm(data[0]);

        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  };



  useEffect(() => {
    if (!isCreditLimitRuleLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_CREDIT_LIMIT_RULES, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setCreditLimitRules(data);
            // setSelectedCreditLimitRule(data[0]);

          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isCreditLimitRuleLoaded]);



  useEffect(() => {
    if (!isTDSLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_TDS, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setTDS(data);

          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isTDSLoaded]);

  // Location

  useEffect(() => {
    if (!isCountryLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1,
      }
      callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setCountry(data);

          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isCountryLoaded]);

  useEffect(() => {
    if (!isBillingCountryLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1

      }
      callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setBillingCountry(data);
            //setSelectedcountry(data[0]);

          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isBillingCountryLoaded]);



  useEffect(() => {
    if (!isCorrespondenceCountryLoaded) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1

      }
      callApi(API_ENDPOINTS.Location_GET_COUNTRY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data
            setCorrespondenceCountry(data);
            //setSelectedcountry(data[0]);

          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isCorrespondenceCountryLoaded]);

  const handleOpenMenu = (setter) => (event) => {
    setter(event.currentTarget);
  };

  const handleCloseMenu = (setter) => () => {
    setter(null);
  };

  const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
    setSelectedOption(option);
    setSelectedID(option ? option.id : null);
    handleCloseMenu();
  };

  const handleAddOption = (label) => () => {
    console.log(`Add new ${label} logic here`);

    if (label === 'TDS') {
      setIsModalOpen(true);
    }
    else if (label === 'Payment Term') {
      setIsPaymentModalOpen(true);
    }
    else if (label === 'Credit Term') {
      setIsCreditTermsModalOpen(true);
    }

  };

  useEffect(() => {
    if (!isDataLoaded) {
      loadPartyType();
    }
  }, [isDataLoaded]);

  const loadPartyType = () => {
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_mode_str: 'active'
    }
    callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PARTY_TYPE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setPartyType(data);
          setSelectedPartyType(data[0]);
          setPartyID(data[0].id);

        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  }


  const handleCountryChange = (event, value) => {
    setSelectedCountry(value);
    setCountryID(value.id);
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_countryid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {

          setState(data);
          if (editPartyID !== 0) {
            if (stateID && state.length > 0) {
              const selected = state.find(c => c.id === stateID);
              if (selected) {
                setSelectedState(selected);
              }
            }
          }
        }
        else {
          setState([]);
          setCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });

  };

  const handleBillingCountryChange = (event, value) => {
    setSelectedBillingCountry(value);
    setBillingCountryID(value.id);
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_countryid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setBillingState(data);
          //setSelectedcountry(data[0]);

        }
        else {
          setBillingState([]);
          setBillingCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });

  };

  const handleCorrespondenceCountryChange = (event, value) => {
    setSelectedCorrespondenceCountry(value);
    setCorrespondenceCountryID(value.id);
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_countryid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setCorrespondenceState(data);
          //setSelectedcountry(data[0]);

        }
        else {
          setCorrespondenceState([]);
          setCorrespondenceCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });

  };

  const handleStateChange = (event, value) => {
    setSelectedState(value);
    setStateID(value.id);
    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_stateid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setCity(data);
          //setSelectedcountry(data[0]);

        }
        else {

          setCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });

  };

  const handleBillingStateChange = (event, value) => {
    setSelectedBillingState(value);
    setBillingStateID(value.id);

    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_stateid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setBillingCity(data);
          //setSelectedcountry(data[0]);

        }
        else {
          setCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  };


  const handlecorrespondenceStateChange = (event, value) => {
    setSelectedCorrespondanceState(value);
    setCorrespondanceStateID(value.id);

    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_stateid: value.id,
    }
    callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setCorrespondenceCity(data);
          //setSelectedcountry(data[0]);

        }
        else {
          setCorrespondenceCity([]);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  };

  const handleCopyBillingToShipping = () => {
    const confirm = window.confirm(`Are you sure you want to copy the billing address to the shipping address?`);

    if (!confirm) {
      return;
    }
    setShipingAddressLine1(billingAddressLine1);
    setSelectedBillingCountry(selectedCountry);
    setSelectedBillingState(selectedState);
    setSelectedBillingCity(selectedCity);
    setShippingPincode(pincode);
    setShippingPhoneNumber(phoneNumber);
    setShippingFaxNumber(faxNumber);

    setBillingCountryID(countryID);
    setBillingStateID(stateID);
    setBillingCityID(cityID);

    setShippingEmail2(email2);
    setShippingPhoneNumber2(phoneNumber2);
    setShippingArea(billingarea);
    setShippingContactPerson(billingcontactperson);

  };

  const handleCopyBillingToCorrespondenceAddress = () => {
    const confirm = window.confirm(`Are you sure you want to copy the billing address to the correspondence address?`);

    if (!confirm) {
      return;
    }
    setCorrespondenceAddressLine1(billingAddressLine1);
    setSelectedCorrespondenceCountry(selectedCountry);
    setSelectedCorrespondanceState(selectedState);
    setSelectedCorrespondenceCity(selectedCity);
    setCorrespondencePincode(pincode);
    setCorrespondancePhoneNumber(phoneNumber);
    setCorrespondancePhoneNumber2(phoneNumber2);
    setCorrespondanceEmail1(faxNumber);
    setCorrespondanceEmail2(email2);
    setCorrespondenceCountryID(countryID);
    setCorrespondanceStateID(stateID);
    setCorrespondenceCityID(cityID);
    setCorrespondenceArea(billingarea);
    setCorrespondenceContactPerson(billingcontactperson);

  };

  const handleCityChange = (event, value) => {
    setSelectedCity(value);
    setCityID(value.id);
  };

  const handleBillingCityChange = (event, value) => {
    setSelectedBillingCity(value);
    setBillingCityID(value.id);
  };



  const handleCorrespondenceCityChange = (event, value) => {
    setSelectedCorrespondenceCity(value);
    setCorrespondenceCityID(value.id);
  };

  const handleSalutationChange = (event, value) => {
    setSalutation(value);
    setSelectedSalutation(value ? value.Description : '');
  };

  const isValidPAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan.toUpperCase());


  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        try {
          const result = reader.result;
          const base64 = result.split(',')[1]; // Safely remove MIME prefix
          resolve(base64);
        } catch (err) {
          reject(err);
        }
      };
      reader.onerror = reject;
    });
  };



  const isBlob = (file) => file instanceof Blob || file instanceof File;

  const prepareBankDetails = async () => {
    try {
      const updatedBankDetails = await Promise.all(
        bankDetails.map(async (item) => {
          let cancelledChequeBase64 = null;
          let rtgsDetailBase64 = null;
          let bankLetterBase64 = null;

          try {
            if (isBlob(item.cancelledCheque)) {
              cancelledChequeBase64 = await convertFileToBase64(item.cancelledCheque);
            } else if (typeof item.cancelledCheque === 'string') {
              cancelledChequeBase64 = item.cancelledCheque;
            }
          } catch (err) {
            console.error("Error converting Cancelled Cheque:", err);
          }

          try {
            if (isBlob(item.rtgsDetail)) {
              rtgsDetailBase64 = await convertFileToBase64(item.rtgsDetail);
            } else if (typeof item.rtgsDetail === 'string') {
              rtgsDetailBase64 = item.rtgsDetail;
            }
          } catch (err) {
            console.error("Error converting RTGS Detail:", err);
          }

          try {
            if (isBlob(item.bankLetter)) {
              bankLetterBase64 = await convertFileToBase64(item.bankLetter);
            } else if (typeof item.bankLetter === 'string') {
              bankLetterBase64 = item.bankLetter;
            }
          } catch (err) {
            console.error("Error converting Bank Letter:", err);
          }

          return {
            ...item,
            cancelledCheque: cancelledChequeBase64,
            cancelledCheque_file_name: item.cancelledCheque?.name || item.cancelledCheque_file_name || null,
            rtgsDetail: rtgsDetailBase64,
            rtgsDetail_file_name: item.rtgsDetail?.name || item.rtgsDetail_file_name || null,
            bankLetter: bankLetterBase64,
            bankLetter_file_name: item.bankLetter?.name || item.bankLetter_file_name || null,
          };
        })
      );

      return updatedBankDetails;
    } catch (err) {
      console.error("prepareBankDetails error:", err);
      return [];
    }
  };








  const handleSubmit = async (event) => {
    event.preventDefault();

    let pkey_mode = 0;
    let u_partyID = 0;

    if (editPartyID != 0) { pkey_mode = 1; u_partyID = editPartyID; }
    const preparedBankDetails = await prepareBankDetails();

    // Validate required fields
    const missingFields = [];

    if (!selectedSalutation) missingFields.push("Salutation");
    if (!firstName) missingFields.push("First Name");
    if (!partyID) missingFields.push("Vendor Type");
    if (!companyName) missingFields.push("Company Name");
    if (!partyDisplayName) missingFields.push("Display Name");

    if (!partyEmail) missingFields.push("Email");
    //if (!partyMobile) missingFields.push("Mobile Number");

    // if (!currencyID) missingFields.push("Currency");
    // if (!paymentTermsID) missingFields.push("Payment Terms");
    // if (!creditTermsID) missingFields.push("Credit Terms");
    // if (!creditTermsRulesID) missingFields.push("Credit Term Rules");
    //if (!tdsID) missingFields.push("TDS");

    if (!billingAddressLine1) missingFields.push("Billing Address");
    if (!countryID) missingFields.push("Billing Country");
    if (!stateID) missingFields.push("Billing State");
    if (!cityID) missingFields.push("Billing City");
    if (!pincode) missingFields.push("Billing Pincode");
    if (!billingcontactperson) missingFields.push("Billing Contact Person");
    if (!phoneNumber) missingFields.push("Billing Phone Number 1");

    if (!shippingAddressLine1) missingFields.push("Shipping Address");
    if (!billingCountryID) missingFields.push("Shipping Country");
    if (!billingStateID) missingFields.push("Shipping State");
    if (!billingCityID) missingFields.push("Shipping City");
    if (!shippingPincode) missingFields.push("Shipping Pincode");
    if (!shippingcontactperson) missingFields.push("Shipping Contact Person");
    if (!shippingPhoneNumber) missingFields.push("Shipping Phone Number 1");

    if (!correspondenceAddressLine1) missingFields.push("Correspondence Address");
    if (!correspondenceCountryID) missingFields.push("Correspondence Country");
    if (!correspondanceStateID) missingFields.push("Correspondence State");
    if (!correspondenceCityID) missingFields.push("Correspondence City");
    if (!correspondencePincode) missingFields.push("Correspondence Pincode");
    if (!correspondencecontactperson) missingFields.push("Correspondence Contact Person");
    if (!correspondancePhoneNumber) missingFields.push("Correspondence Phone Number 1");

    if (!state) missingFields.push("Status");
    //if (!isValidPAN(partyPAN_Number)) missingFields.push("Invalid PAN number");
    // if (!isValidGST(partyGST_Number)) missingFields.push("Invalid GST number");

    if (partyPAN_Number && !isValidPAN(partyPAN_Number)) {
      missingFields.push("Invalid PAN number)");
    }

    if (partyGST_Number && !gstRegex.test(partyGST_Number)) {
      missingFields.push("GST Number (Invalid Format)");
    }


    if (missingFields.length > 0) {
      const formattedMessage = `Please fill the following fields:\n${missingFields.map(f => `${f}`).join(',\n')}`;
      setParentRollSeverityvalue('error');
      setParentRollAlertTitleValue('Missing Fields');
      setParentRollMessageValue(formattedMessage);
      setParentRollMsgOpen(true);
      return;
    }

    const partyData = {

      p_companyid: localStorage.getItem('companyid'),
      p_salutation: selectedSalutation,
      p_first_name: firstName,
      p_second_name: secondName,
      p_party_id: editPartyID,
      p_party_type_id: partyID,
      p_company_name: companyName,
      p_party_display_name: partyDisplayName,
      p_party_email: partyEmail,
      p_party_work_phone: partyWorkPhone,
      p_party_mobile: partyMobile,

      p_party_pan_number: partyPAN_Number,

      p_party_msme_register: partyMSME_Register,
      p_party_msme_register_number: partyMSME_Number ? null : '',
      p_party_currency_id: currencyID,
      p_party_payment_terms_id: paymentTermsID,
      p_party_credit_terms_id: creditTermsID,
      p_party_credit_terms_rules_id: creditTermsRulesID,
      p_party_tds_id: tdsID,

      p_party_contact_list: contacts,
      p_party_bank_details: preparedBankDetails,//bankDetails,
      p_party_shipping_list: shippingAddress,

      // billing address
      p_billing_addressline1: billingAddressLine1,
      p_billing_country: countryID,
      p_billing_state: stateID,
      p_billing_city: cityID,
      p_billing_pincode: pincode,
      p_billing_phone: phoneNumber,
      p_billing_faxnumber: faxNumber,
      p_billing_emailid2: email2,
      p_billing_phone2: phoneNumber2,
      p_billing_area: billingarea,
      p_billing_contact_person: billingcontactperson,


      // shipping address
      p_shipping_addressline1: shippingAddressLine1,
      p_shipping_country: billingCountryID,
      p_shipping_state: billingStateID,
      p_shipping_city: billingCityID,
      p_shipping_pincode: shippingPincode,
      p_shipping_phone: shippingPhoneNumber,
      p_shipping_faxnumber: shippingfaxNumber,
      p_shipping_emailid2: shippingEmail2,
      p_shipping_phone2: shippingPhoneNumber2,
      p_shipping_area: shippingarea,
      p_shipping_contact_person: shippingcontactperson,

      // correspondence address
      p_correspondence_addressline1: correspondenceAddressLine1,
      p_correspondence_country: correspondenceCountryID,
      p_correspondence_state: correspondanceStateID,
      p_correspondence_city: correspondenceCityID,
      p_correspondence_pincode: correspondencePincode,
      p_correspondence_phone1: correspondancePhoneNumber,
      p_correspondence_emailid1: correspondanceEmail1,
      p_correspondence_emailid2: correspondanceEmail2,
      p_correspondence_phone2: correspondancePhoneNumber2,
      p_correspondence_area: correspondenceArea,
      p_correspondence_contact_person: correspondencecontactperson,

      p_mode: pkey_mode,
      p_party_gst_number: partyGST_Number,
      p_panfile: panFileBase64,
      p_gstfile: gstFileBase64,
      p_msmefile: msmeFileBase64,
      p_panfile_filename: panFile ? panFile : '',
      p_gstfile_filename: gstFile ? gstFile : '',
      p_msmefile_filename: msmeFile ? msmeFile : '',
      p_status: status,
      p_unit: unit,
      p_id_parent_party: selectedPartyID,
      p_fysalevalue: fysalevalue,
      p_tcsapplicable: checkedTcsApplicable,
      p_notes: customerNotes,
    };





    callApi(API_ENDPOINTS.AddPartyDetails, 'POST', { 'Content-Type': 'application/json' }, partyData)
      .then(data => {
        if (data && data.length > 0) {

          if (editPartyID != 0) { setParentRollMessageValue('Vendor Data Updated Successfully'); }
          else { setParentRollMessageValue('New Vendor Added Successfully'); }

          setParentRollSeverityvalue('success');
          setParentRollAlertTitleValue('Info');
          setParentRollMsgOpen(true);
          setSaveButtonDisabled(true);
        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);


      });

  };




  const [isLoadEditParty, setLoadEditParty] = useState(false);



  useEffect(() => {
    if (!isLoadEditParty) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_partyid: editPartyID,
      }
      callApi(API_ENDPOINTS.GETPartyDetails, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            // Update state with fetched data

            const fetchedSalutation = (data[0].salutation);
            setSelectedSalutation(data[0].salutation);
            const matchingOption = salutationOptions.find(option => option.Description === fetchedSalutation);
            setSalutation(matchingOption);

            setFirstName(data[0].first_name);
            setSecondName(data[0].second_name);
            setCompanyName(data[0].company_name);
            setPartyDisplayName(data[0].display_name);
            setPartyEmail(data[0].email);
            setPartyWorkPhone(data[0].work_phone);
            setPartyMobile(data[0].mobile);
            setPartyPAN_Number(data[0].pan_number);
            setPartyMSME_Register(data[0].msme_registration);
            setPartyGST_Number(data[0].gst_number);
            setUnit(data[0].unit);
            setSelectedPartyID(data[0].id_parent_party);
            setFysalevalue(data[0].fysalevalue);
            setCheckedTcsApplicable(data[0].tcsapplicable); // === 'Y' ? true : false
            setCustomerNotes(data[0].notes);

            partyList.forEach(party => {
              if (party.id === data[0].id_parent_party) {
                setSelectedParty(party);
              }

            });

            // other details
            setCurrencyID(data[0].currency_id);
            setPaymentTermsID(data[0].payment_terms_id);
            setCreditTermsID(data[0].credit_terms_id);
            setCreditTermsRulesID(data[0].credit_limit_rules_id);
            setTDSID(data[0].tds_id);

            // address
            setBillingAddressLine1(data[0].billing_address);
            setCountryID(data[0].billing_country_id);
            setStateID(data[0].billing_state_id);
            setCityID(data[0].billing_city_id);
            setPincode(data[0].billing_pincode);
            setPhoneNumber(data[0].billing_phone);
            setFaxNumber(data[0].billing_faxnumber);
            setPhoneNumber2(data[0].billing_phonenumber2);
            setEmail2(data[0].billing_emailid2);
            setBillingArea(data[0].billing_area);
            setBillingContactPerson(data[0].billing_contactperson);



            setShipingAddressLine1(data[0].shipping_address);
            setBillingCountryID(data[0].shipping_country_id);
            setBillingStateID(data[0].shipping_state_id);
            setBillingCityID(data[0].shipping_city_id);
            setShippingPincode(data[0].shipping_pincode);
            setShippingPhoneNumber(data[0].shipping_phone);
            setShippingFaxNumber(data[0].shipping_faxnumber);
            setShippingPhoneNumber2(data[0].shipping_phonenumber2);
            setShippingEmail2(data[0].shipping_emailid2);
            setShippingArea(data[0].shipping_area);
            setShippingContactPerson(data[0].shipping_contactperson);



            setCorrespondenceAddressLine1(data[0].correspondence_address);
            setCorrespondenceCountryID(data[0].correspondence_country_id);
            setCorrespondanceStateID(data[0].correspondence_state_id);
            setCorrespondenceCityID(data[0].correspondence_city_id);

            setCorrespondencePincode(data[0].correspondence_pincode);
            setCorrespondancePhoneNumber(data[0].correspondence_phonenumber1);
            setCorrespondanceEmail1(data[0].correspondence_emailid1);
            setCorrespondanceEmail2(data[0].correspondence_emailid2);
            setCorrespondancePhoneNumber2(data[0].correspondence_phonenumber2);
            setCorrespondenceContactPerson(data[0].correspondence_contactperson);
            setCorrespondenceArea(data[0].correspondence_area);



            setPartyMSME_Number(data[0].msme_registration_number);

            // Parse bank_details if it's a JSON string
            const bankDetailsData = typeof data[0].bank_details === 'string'
              ? JSON.parse(data[0].bank_details)
              : data[0].bank_details;
            setBankDetails(Array.isArray(bankDetailsData) ? bankDetailsData : []);

            // Parse Shipping Detail
            const ShippingDetailsData = typeof data[0].shipping_address_list === 'string'
              ? JSON.parse(data[0].shipping_address_list)
              : data[0].shipping_address_list;
            setShippingAddress(Array.isArray(ShippingDetailsData) ? ShippingDetailsData : []);

            // Parse contact_details if it's a JSON string
            const contactDetailsData = typeof data[0].person_details === 'string'
              ? JSON.parse(data[0].person_details)
              : data[0].person_details;
            setContacts(Array.isArray(contactDetailsData) ? contactDetailsData : []);

            // Parse contact_details if it's a JSON string
            const documentDetailsData = typeof data[0].document_details === 'string'
              ? JSON.parse(data[0].document_details)
              : data[0].document_details;

            if (documentDetailsData && documentDetailsData.length > 0) {
              documentDetailsData.forEach((doc) => {
                if (doc.document_type === 'PAN' && doc.document_value) {
                  const encoded = doc.document_value;
                  const uriEncoded = encoded.replace(/\\x/g, '%');
                  const base64Candidate = decodeURIComponent(uriEncoded); // might be base64 or plain text    
                  setPanFile(doc.document_name);
                  setPanFileBase64(base64Candidate);
                }
                else if (doc.document_type === 'GST' && doc.document_value) {
                  const encoded = doc.document_value;
                  const uriEncoded = encoded.replace(/\\x/g, '%');
                  const base64Candidate = decodeURIComponent(uriEncoded); // might be base64 or plain text    
                  setGstFile(doc.document_name);

                  setGstFileBase64(base64Candidate);
                }
                else if (doc.document_type === 'MSME' && doc.document_value) {
                  const encoded = doc.document_value;
                  const uriEncoded = encoded.replace(/\\x/g, '%');
                  const base64Candidate = decodeURIComponent(uriEncoded); // might be base64 or plain text    
                  setMSMEFile(doc.document_name);
                  setMSMEFileBase64(base64Candidate);
                }
              });
            }
            setUpdateProgress(false);
            setStatus(data[0].status);
          }
          else {
            setState([]);
            setCity([]);
          }
        })
        .catch(error => {
          // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          // 

        });
    }
  }, [isLoadEditParty, partyList]);




  useEffect(() => {
    if (countryID && country.length > 0) {
      const selected = country.find(c => c.id === countryID);
      if (selected) {
        setSelectedCountry(selected);
      }
    }
  }, [countryID, country]);

  useEffect(() => {

    if (stateID && state.length == 0 && countryID && country.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_countryid: countryID,
      }
      callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setState(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }

    if (stateID && state.length > 0) {
      const selected = state.find(c => c.id === stateID);
      if (selected) {
        setSelectedState(selected);
      }
    }
  }, [stateID, state]);





  const [cityLoad, setCityLoad] = useState(false);

  useEffect(() => {
    if (stateID && state.length === 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_stateid: stateID,
      };

      callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setCity(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }

    if (cityID && city.length > 0) {
      const selected = city.find(c => c.id === cityID);
      if (selected) {
        setSelectedCity(selected);
        setCityLoad(true);
      }
    }
  }, [stateID, city, cityID]);



  useEffect(() => {
    if (billingCountryID && billingCountry.length > 0) {
      const selected = billingCountry.find(c => c.id === billingCountryID);
      if (selected) {
        setSelectedBillingCountry(selected);
      }
    }
  }, [billingCountryID, billingCountry]);

  useEffect(() => {
    if (billingStateID && billingState.length === 0 && billingCountryID && billingCountry.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_countryid: billingCountryID,
      }
      callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setBillingState(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }

    if (billingStateID && billingState.length > 0) {
      const selected = billingState.find(c => c.id === billingStateID);
      if (selected) {
        setSelectedBillingState(selected);
      }
    }
  }, [billingStateID, billingState]);

  useEffect(() => {

    if (billingStateID && billingState.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_stateid: billingStateID,
      }
      callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setBillingCity(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
    if (billingCityID && billingCity.length > 0) {
      const selected = billingCity.find(c => c.id === billingCityID);
      if (selected) {
        setSelectedBillingCity(selected);
      }
    }
  }, [billingStateID, billingCityID, billingCity]);


  //correspondence country state city
  useEffect(() => {
    if (correspondenceCountryID && correspondenceCountry.length > 0) {
      const selected = correspondenceCountry.find(c => c.id === correspondenceCountryID);
      if (selected) {
        setSelectedCorrespondenceCountry(selected);
      }
    }
  }
    , [correspondenceCountryID, correspondenceCountry]);

  useEffect(() => {
    if (correspondanceStateID && correspondenceState.length === 0 && correspondenceCountryID && correspondenceCountry.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_countryid: correspondenceCountryID,
      }
      callApi(API_ENDPOINTS.Location_GET_STATE, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setCorrespondenceState(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
    if (correspondanceStateID && correspondenceState.length > 0) {
      const selected = correspondenceState.find(c => c.id === correspondanceStateID);
      if (selected) {
        setSelectedCorrespondanceState(selected);
      }
    }
  }, [correspondanceStateID, correspondenceState]);

  useEffect(() => {
    if (correspondanceStateID && correspondenceState.length > 0) {
      const para = {
        p_companyid: localStorage.getItem('companyid'),
        p_stateid: correspondanceStateID,
      }
      callApi(API_ENDPOINTS.Location_GET_CITY, 'POST', { 'Content-Type': 'application/json' }, para)

        .then(data => {
          if (data && data.length > 0) {
            setCorrespondenceCity(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
  }, [correspondanceStateID, correspondenceState]);


  useEffect(() => {
    if (correspondenceCityID && correspondenceCity.length > 0) {
      const selected = correspondenceCity.find(c => c.id === correspondenceCityID);
      if (selected) {
        setSelectedCorrespondenceCity(selected);
      }
    }
  }, [correspondenceCityID, correspondenceCity]);

  useSelectedOption(countryID, country, setSelectedCountry);
  useSelectedOption(stateID, state, setSelectedState);
  useSelectedOption(cityID, city, setSelectedCity);
  useSelectedOption(billingCountryID, billingCountry, setSelectedBillingCountry);
  useSelectedOption(billingStateID, billingState, setSelectedBillingState);
  useSelectedOption(billingCityID, billingCity, setSelectedBillingCity);

  const callError = (serverityval, msg, title) => {
    // Update state with error message        
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };



  // rfresh data 
  const handleCloseModal = () => {
    setIsModalOpen(false);

    const para = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
    }
    callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_TDS, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          // Update state with fetched data
          setTDS(data);
          // setSelectedTDS(data[0]);

        }
      })
      .catch(error => {
        // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        // 

      });
  };


  const handleBankAccountCloseModal = () => {
    setIsModalAccountOpen(false);
    loadBankAccountByID(0);

  };

  const handlePartyTypeCloseModal = () => {
    setIsModalPartyTypeOpen(false);

    loadPartyType();


  };

  const handlePaymentTermsCloseModal = () => {
    setIsPaymentModalOpen(false);
    fetchPaymentTerms();
  };

  const handleCreditTermsCloseModal = () => {
    setIsCreditTermsModalOpen(false);
    fetchCreditTerms();
  };

  const handleDownload = (document_type) => {
    try {
      if (!document_type) {
        alert("No document type provided.");
        return;
      }
      let commanfile = null;
      let commanfilename = '';
      if (document_type === 'PAN') {
        commanfile = panFileBase64;
        commanfilename = panFile;
      }
      else if (document_type === 'GST') {
        commanfile = gstFileBase64;
        commanfilename = gstFile;
      }
      else if (document_type === 'MSME') {
        commanfile = msmeFileBase64;
        commanfilename = msmeFile;
      }

      if (commanfile) {
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${commanfile}`;
        link.download = commanfilename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert("No file found.");
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  };


  // load city state code  based on pincode 
  const handlePincode = async (code, isShipping = false) => {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${code}`);
      const data = await res.json();
      const postOffice = data[0]?.PostOffice?.[0];

      if (!postOffice) return;

      const { District, State, Country } = postOffice;
      const cityObj = city.find(c => c.description === District);
      const stateObj = state.find(s => s.description === State);
      const countryObj = country.find(c => c.description === Country);

      const para = {
        p_country: Country,
        p_state: State,
        p_city: District,
      };

      const locationData = await callApi(
        API_ENDPOINTS.Location_GET_LOCATION_ID,
        'POST',
        { 'Content-Type': 'application/json' },
        para
      );

      if (locationData && locationData.length > 0) {
        const { id_country_val, id_state_val, id_city_val } = locationData[0];
        if (isShipping) {
          setBillingCountryID(id_country_val);
          setBillingStateID(id_state_val);
          setBillingCityID(id_city_val);
        } else {
          setCountryID(id_country_val);
          setStateID(id_state_val);
          setCityID(id_city_val);
        }
      }

      if (isShipping) {
        setSelectedBillingCity(cityObj || { description: District });
        setSelectedBillingState(stateObj || { description: State });
        setSelectedBillingCountry(countryObj || { description: Country });
      } else {
        setSelectedCity(cityObj || { description: District });
        setSelectedState(stateObj || { description: State });
        setSelectedCountry(countryObj || { description: Country });
      }

    } catch (error) {
      console.error("Error fetching location info", error);
      setParentRollSeverityvalue('error');
      setParentRollMessageValue(error.message);
      setParentRollAlertTitleValue('Error');
      setParentRollMsgOpen(true);
    }
  };



  useEffect(() => {
    if (pincode.length === 6) {
      handlePincode(pincode);
    }
  }, [pincode])

  useEffect(() => {
    if (shippingPincode.length === 6) {
      handlePincode(shippingPincode, true);
    }
  }, [shippingPincode])







  useEffect(() => {
    const updatePincodeDetails = async () => {
      const updatedAddresses = await Promise.all(
        shippingAddress.map(async (shipto, index) => {
          const pincode = shipto.pincode?.trim();
          if (!pincode || pincode.length !== 6) return shipto;

          try {
            const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
            const data = await res.json();
            const postOffice = data[0]?.PostOffice?.[0];

            if (!postOffice) return shipto;

            const { District, State, Country } = postOffice;

            const para = {
              p_country: Country,
              p_state: State,
              p_city: District,
            };

            const locationData = await callApi(
              API_ENDPOINTS.Location_GET_LOCATION_ID,
              'POST',
              { 'Content-Type': 'application/json' },
              para
            );

            if (locationData && locationData.length > 0) {
              const { id_country_val, id_state_val, id_city_val } = locationData[0];

              return {
                ...shipto,
                city: District,
                state: State,
                country: Country,
                countryId: id_country_val,
                stateId: id_state_val,
                cityId: id_city_val,
              };
            }

          } catch (error) {
            console.error('Error fetching location info:', error);
          }

          return shipto; // fallback to original if error or invalid
        })
      );

      setShippingAddress(updatedAddresses);
    };

    updatePincodeDetails();
  }, [JSON.stringify(shippingAddress.map(s => s.pincode?.trim()))]);



  useEffect(() => {
    if (!updateProgress) {
      bankDetails.forEach((bank, index) => {
        const ifsc = bank.ifsc?.trim();
        if (ifsc && ifsc.length === 11) {
          fetch(`https://ifsc.razorpay.com/${ifsc}`)
            .then(res => {
              if (!res.ok) throw new Error("Invalid IFSC");
              return res.json();
            })
            .then(data => {
              const updated = [...bankDetails];
              updated[index] = {
                ...updated[index],
                bankName: data.BANK,
                branchName: data.BRANCH,
                bankAddress: data.ADDRESS,
                contactNumber: data.CONTACT?.replace(/^(\+91)/, '') // Removes +91 from start
              };
              setBankDetails(updated);
            })
            .catch(err => {
              console.error(`IFSC fetch failed for index ${index}`, err);
            });
        }
      });
    }

  }, [bankDetails.map(b => b.ifsc).join(',')]); // triggers when any IFSC changes







  return (<>
    <Box padding={0}>

      <Header title={editPartyID == 0 ? 'New Supplier' : 'Edit Supplier'} subtitle="" callback={callback} />
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 1,
          py: 1
        }}
      >
        <Typography variant="h6"  >
          <span style={{ color: 'red' }}>*</span> Mandatory fields
        </Typography>
      </Box>



      {/* Message box detail */}
      <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

      <form onSubmit={handleSubmit}>

        <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>
          <Grid container  >

             <Grid item xs={12} xl={12} >
              <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Supplier Type <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    value={selectedPartyType}
                    onChange={(event, newValue) => {
                      setSelectedPartyType(newValue);
                      if (newValue) {
                        setPartyID(newValue.id);
                      } else {
                        setPartyID(null); // optional: reset to null when cleared
                      }
                    }}
                    options={partyType}
                    getOptionLabel={(option) => option?.description || ''}
                    renderInput={(params) => (
                      <TextField color="secondary" {...params} label="" required variant="outlined" />
                    )}
                  />

                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={.5} xl={.5}>
                  <Tooltip title="Add New Supplier Type" arrow>
                    <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModalPartyType} >
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>


              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={0}>
              <Grid container padding="12px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >


                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Primary Contact  <span style={{ color: 'red' }}>*</span>
                    <CustomTooltip
                      title={
                        <span>
                          <b>The name your enter here will be for primary contact. you can continue to add multiple contact to add multiple contact persons from the detail page.</b> <br />
                        </span>}
                    >
                      <IconButton sx={{ marginLeft: "5px" }}>
                        <InfoOutlinedIcon sx={{ color: colors.blueAccent[500], fontSize: "16px" }} />
                      </IconButton>
                    </CustomTooltip>
                  </Typography>

                </Grid>

                <Grid item xs={12} sm={11} md={1.5} lg={1.3} xl={1.3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    required
                    options={salutationOptions}
                    value={salutation}
                    getOptionLabel={(option) => option.Description || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.Description === value?.Description
                    }
                    onChange={handleSalutationChange}
                    renderInput={(params) => (
                      <TextField color='secondary' {...params} label="Salutation" required />
                    )}
                  />

                </Grid>

                <Grid item xs={12} sm={11} md={2.3} lg={1.7} xl={1.7}>
                  <TextField value={firstName} onChange={(e) => setFirstName(e.target.value)} size="small" label="First Name" color="secondary" required fullWidth variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={11} md={2.3} lg={1.7} xl={1.7}>
                  <TextField value={secondName} onChange={(e) => setSecondName(e.target.value)} size="small" label="Last Name" color="secondary" fullWidth variant="outlined" />
                </Grid>
              </Grid>
            </Grid>

         

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left" >
                    Company Name  <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>
                  <TextField
                    required
                    color="secondary"
                    value={companyName}
                    onChange={handleCompanyNameChange}
                    fullWidth
                    size="small"
                    variant="outlined"
                  />

                </Grid>


              </Grid>
            </Grid>


            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Supplier Display Name  <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>

                  <TextField
                    required
                    color="secondary"
                    value={partyDisplayName}
                    onChange={handleDisplayNameChange}
                    fullWidth
                    size="small"
                    variant="outlined"
                  />

                </Grid>


              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                   Company Unit
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>

                  <TextField color="secondary" value={unit} onChange={(e) => setUnit(e.target.value)} fullWidth size="small" label="" variant="outlined" />
                </Grid>


              </Grid>
            </Grid>


            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Email <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>
                  {/* <TextField value={partyEmail} onChange={(e) => setPartyEmail(e.target.value)} type="email" fullWidth size="small" label="" required variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email />
                        </InputAdornment>
                      ),
                    }} /> */}
                  <TextField
                    value={partyEmail}
                    onChange={(e) => setPartyEmail(e.target.value.toLowerCase())}
                    type="email"
                    fullWidth
                    color="secondary"
                     placeholder="example@company.com"
                    size="small"
                    // label="Email Address"
                    required
                    variant="outlined"
                    error={partyEmail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(partyEmail)}
                    helperText={
                      partyEmail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(partyEmail)
                        ? 'Invalid email format'
                        : ''
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />

                </Grid>


              </Grid>
            </Grid>



            <Grid item xs={12} xl={12} >
              <Grid container padding="12px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Phone
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={2} lg={1.5} xl={1.5}>


                  <TextField
                    value={partyWorkPhone}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d*$/.test(input) && input.length <= 10) {
                        setPartyWorkPhone(input);
                      }
                    }}
                    color="secondary"
                    fullWidth
                    size="small"
                    type="tel"
                    label="Work Phone"
                    // required
                    variant="outlined"
                    error={partyWorkPhone !== '' && !/^[0-9]{10}$/.test(partyWorkPhone)}
                    helperText={
                      partyWorkPhone !== '' && !/^[0-9]{10}$/.test(partyWorkPhone)
                        ? 'Enter a valid 10-digit phone number'
                        : ''
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon fontSize="small"/>
                        </InputAdornment>
                      ),
                    }}
                  />

                </Grid>

                <Grid item xs={12} sm={11} md={1.8} lg={1.5} xl={1.5}>


                  <TextField
                    value={partyMobile}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d*$/.test(input) && input.length <= 10) {
                        setPartyMobile(input);
                      }
                    }}
                    color="secondary"

                    fullWidth
                    size="small"
                    type="tel"
                    label="Mobile Phone"
                    // required
                    variant="outlined"
                    error={partyMobile !== '' && !/^[0-9]{10}$/.test(partyMobile)}
                    helperText={
                      partyMobile !== '' && !/^[0-9]{10}$/.test(partyMobile)
                        ? 'Enter a valid 10-digit mobile number'
                        : ''
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIphoneIcon fontSize="small"/>
                        </InputAdornment>
                      ),
                    }}
                  />



                </Grid>


              </Grid>
            </Grid>


            {/* STATUS */}
            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Status <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={3} xl={3}>
                  <FormControl fullWidth margin="dense" size='small' color="secondary">

                    <Select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="InActive">InActive</MenuItem>
                    </Select>
                  </FormControl>

                </Grid>


              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Parent Company
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={4.7} xl={4.5}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={partyList.filter(p => p && typeof p === 'object' && p.companyname)}
                    value={partyList.find(p => p?.id === selectedParty?.id) || null}
                    onChange={(event, newValue) => {
                      setSelectedParty(newValue);
                      setSelectedPartyID(newValue?.id || null);
                    }}
                    getOptionLabel={(option) =>
                      (option && typeof option === 'object' && option.companyname)
                        ? option.companyname
                        : ''
                    }
                    filterOptions={(options, state) => {
                      return filter(
                        options.filter(p => p && typeof p === 'object' && typeof p.companyname === 'string'),
                        state
                      );
                    }}
                    renderInput={(params) => (
                      <TextField color="secondary" {...params} label="" variant="outlined" />
                    )}
                    renderOption={(props, option) => (
                      <Box sx={{ backgroundColor: colors.primary[400] }} component="li" {...props} display="flex" alignItems="center">
                        <Avatar src={option.avatarUrl} alt={option.companyname} sx={{ marginRight: 2 }} />
                        <Box display="flex" flexDirection="column">
                          <Typography variant="subtitle2" component="div">
                            {option.companyname}
                          </Typography>
                          <Box display="flex" justifyContent="space-between" width="100%">
                            <Box display="flex" alignItems="center">
                              <EmailOutlined fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.email}
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem sx={{ marginX: 1 }} />
                            <Box display="flex" alignItems="center">
                              <Business fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.name}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>



            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">

                  <Box mt={1}  >

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="contained"
                        aria-label="full width tabs example"
                      >
                        <Tab sx={{ textTransform: "none" }} label="Other Details" {...a11yProps(0)} />
                        <Tab sx={{ textTransform: "none" }} label="Address" {...a11yProps(1)} />
                        <Tab sx={{ textTransform: "none" }} label="Contact Persons" {...a11yProps(2)} />
                        <Tab sx={{ textTransform: "none" }} label="Bank Details" {...a11yProps(3)} />
                      </Tabs>
                    </Box>

                    <SwipeableViews
                      axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                      index={value}
                      onChangeIndex={handleChangeIndex}
                    >
                      <TabPanel value={value} index={0} dir={theme.direction}>
                        <Box>
                          <Grid container>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} textAlign="left" >
                                    GST No <span style={{ color: 'red' }}>*</span>
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={3.8} lg={3.6} xl={3.9}>
                                  {/* <TextField value={partyGST_Number} onChange={(e) => setPartyGST_Number(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}
                                  <TextField
                                    value={partyGST_Number}
                                    onChange={(e) => {
                                      const input = e.target.value.toUpperCase();
                                      if (input.length <= 15) {
                                        setPartyGST_Number(input);
                                      }
                                    }}
                                    fullWidth
                                    size="small"
                                    color="secondary"
                                   placeholder="(e.g. 22ABCDE1234F1Z5)"
                                    variant="outlined"
                                    error={!isGSTValid}
                                    helperText={!isGSTValid ? 'Invalid GST format (e.g. 22ABCDE1234F1Z5)' : ''}
                                  />

                                </Grid>

                                {/* File Upload for PAN Document */}
                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>

                                  <Tooltip title="Upload GST Document">
                                    <IconButton color="secondary" component="label">
                                      <CloudUploadIcon />
                                      <input
                                        type="file"
                                        hidden
                                        accept="application/pdf,image/*"
                                        onChange={(e) => handleGSTFileChange(e.target.files[0])}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                  {gstFile && (
                                    <Tooltip title="Download GST Document">
                                      <IconButton color="secondary" onClick={e => handleDownload('GST')} >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                  {gstFile && (
                                    <Typography variant="h6" > ( File Name : <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                      {gstFile}
                                    </span> )</Typography>
                                  )}
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} textAlign="left" >
                                    PAN
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={3.6} lg={3.6} xl={3.9}>
                                  <TextField
                                    value={partyPAN_Number}
                                    onChange={(e) => {
                                      const input = e.target.value.toUpperCase();
                                      if (input.length <= 10) {
                                        setPartyPAN_Number(input);
                                      }
                                    }}
                                    color="secondary"
                                    fullWidth
                                    size="small"
                                    label="PAN Number"
                                    variant="outlined"
                                    error={!isPanValid}
                                    helperText={!isPanValid ? 'Invalid PAN format (e.g. ABCDE1234F)' : ''}
                                  />

                                </Grid>

                                {/* File Upload for PAN Document */}
                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                  <Tooltip title="Upload PAN Document">
                                    <IconButton color="secondary" component="label">
                                      <CloudUploadIcon />
                                      <input
                                        type="file"
                                        hidden
                                        accept="application/pdf,image/*"
                                        onChange={(e) => handlePanFileChange(e.target.files[0])}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                  {panFile && (
                                    <Tooltip title="Download PAN Document">
                                      <IconButton color="secondary" onClick={e => handleDownload('PAN')} >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>

                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                  {panFile && (
                                    <Typography variant="h6" > ( File Name : <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                      {panFile}
                                    </span> )</Typography>
                                  )}
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Tooltip title="Micro, Small and Medium Enterprises registration status" arrow>
                                    <Typography
                                      variant="h6"
                                      fontSize={14}
                                      textAlign="left"
                                      sx={{ cursor: 'help' }}
                                    >
                                      MSME Registered?
                                    </Typography>
                                  </Tooltip>
                                </Grid>

                                <Grid item xs={12} sm={11} md={4} lg={3.6} xl={3.9}>
                                  <FormGroup>
                                    <FormControlLabel control={<Checkbox size="small" color="secondary" checked={partyMSME_Register} onChange={(e) => setPartyMSME_Register(e.target.checked)} />} label="This vendor is MSME registered" />
                                  </FormGroup>
                                  {partyMSME_Register && (
                                    <TextField
                                      value={partyMSME_Number}
                                      onChange={(e) => {
                                        const input = e.target.value.toUpperCase();
                                        // Accept only alphanumeric, up to 15 chars
                                        if (/^[A-Z0-9]*$/.test(input) && input.length <= 15) {
                                          setPartyMSME_Number(input);
                                        }
                                      }}
                                      fullWidth
                                      color="secondary"
                                      size="small"
                                      label="MSME Registration Number"
                                      variant="outlined"
                                      required
                                      error={partyMSME_Number !== '' && !/^[A-Z0-9]{12,15}$/.test(partyMSME_Number)}
                                      helperText={
                                        partyMSME_Number !== '' && !/^[A-Z0-9]{12,15}$/.test(partyMSME_Number)
                                          ? 'Invalid MSME Number (12–15 alphanumeric characters)'
                                          : ''
                                      }
                                    />

                                  )}
                                </Grid>
                                {/* File Upload for PAN Document */}
                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>

                                  <Tooltip title="Upload MSME Document">
                                    <IconButton color="secondary" component="label">
                                      <CloudUploadIcon />
                                      <input
                                        type="file"
                                        hidden
                                        accept="application/pdf,image/*"
                                        onChange={(e) => handleMSMEFileChange(e.target.files[0])}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                  {msmeFile && (
                                    <Tooltip title="Download MSME Document">
                                      <IconButton color="secondary" onClick={e => handleDownload('MSME')} >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                  {msmeFile && (
                                    <Typography variant="h6" > ( File Name : <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                      {msmeFile}
                                    </span> )</Typography>
                                  )}
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Currency
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                  <CustomAutocomplete
                                    label="Currency"
                                    options={currency}
                                    selectedOption={selectedCurrency}
                                    setSelectedOption={setSelectedCurrency}
                                    setAnchorEl={setCurrencyAnchorEl}
                                    anchorEl={currencyAnchorEl}
                                    handleOpenMenu={handleOpenMenu(setCurrencyAnchorEl)}
                                    handleCloseMenu={handleCloseMenu(setCurrencyAnchorEl)}
                                    filterText={currencyFilterText}
                                    setFilterText={setCurrencyFilterText}
                                    handleSelectOption={handleSelectOption(setSelectedCurrency, setCurrencyID)}
                                    handleAddOption={handleAddOption('Currency')}
                                    selectedID={currencyID}
                                    setSelectedID={setCurrencyID}
                                    isRequired={false}
                                  />
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Payment Terms
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                  <CustomAutocomplete
                                    label="Payment Term"
                                    options={paymentTerms}
                                    selectedOption={selectedPaymentTerm}
                                    setSelectedOption={setSelectedPaymentTerm}
                                    setAnchorEl={setPaymentTermAnchorEl}
                                    anchorEl={paymentTermAnchorEl}
                                    handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                                    handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                                    filterText={paymentTermFilterText}
                                    setFilterText={setPaymentTermFilterText}
                                    handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                                    handleAddOption={handleAddOption('Payment Term')}
                                    selectedID={paymentTermsID}
                                    setSelectedID={setPaymentTermsID}
                                    isRequired={false}
                                  />
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Credit Terms
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                  <CustomAutocomplete
                                    label="Credit Term"
                                    options={creditTerms}
                                    selectedOption={selectedCreditTerm}
                                    setSelectedOption={setSelectedCreditTerm}
                                    setAnchorEl={setCreditTermAnchorEl}
                                    anchorEl={creditTermAnchorEl}
                                    handleOpenMenu={handleOpenMenu(setCreditTermAnchorEl)}
                                    handleCloseMenu={handleCloseMenu(setCreditTermAnchorEl)}
                                    filterText={creditTermFilterText}
                                    setFilterText={setCreditTermFilterText}
                                    handleSelectOption={handleSelectOption(setSelectedCreditTerm, setCreditTermsID)}
                                    handleAddOption={handleAddOption('Credit Term')}
                                    selectedID={creditTermsID}
                                    setSelectedID={setCreditTermsID}
                                    isRequired={false}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>




                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Credit Terms rules
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>
                                  <CustomAutocomplete
                                    label="Credit Limit Rule"
                                    options={creditLimitRules}
                                    selectedOption={selectedCreditLimitRule}
                                    setSelectedOption={setSelectedCreditLimitRule}
                                    setAnchorEl={setCreditLimitRuleAnchorEl}
                                    anchorEl={creditLimitRuleAnchorEl}
                                    handleOpenMenu={handleOpenMenu(setCreditLimitRuleAnchorEl)}
                                    handleCloseMenu={handleCloseMenu(setCreditLimitRuleAnchorEl)}
                                    filterText={creditLimitRuleFilterText}
                                    setFilterText={setCreditLimitRuleFilterText}
                                    handleSelectOption={handleSelectOption(setSelectedCreditLimitRule, setCreditTermsRulesID)}
                                    handleAddOption={handleAddOption('Credit Limit Rule')}
                                    selectedID={creditTermsRulesID}
                                    setSelectedID={setCreditTermsRulesID}
                                    isRequired={false}
                                  />
                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Tooltip title="Tax Deducted at Source" arrow>
                                    <Typography
                                      variant="h6"
                                      fontSize={14}
                                      marginTop={0}
                                      textAlign="left"
                                      sx={{ cursor: 'help' }}
                                    >
                                      TDS
                                    </Typography>
                                  </Tooltip>

                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={3.6} xl={3.9}>

                                  <CustomAutocomplete
                                    label="TDS"
                                    options={tds}
                                    selectedOption={selectedTDS}
                                    setSelectedOption={setSelectedTDS}
                                    setAnchorEl={setTDSAnchorEl}
                                    anchorEl={tdsAnchorEl}
                                    handleOpenMenu={handleOpenMenu(setTDSAnchorEl)}
                                    handleCloseMenu={handleCloseMenu(setTDSAnchorEl)}
                                    filterText={tdsFilterText}
                                    setFilterText={setTDSFilterText}
                                    handleSelectOption={handleSelectOption(setSelectedTDS, setTDSID)}
                                    handleAddOption={handleAddOption('TDS')}
                                    selectedID={tdsID}
                                    setSelectedID={setTDSID}
                                    isRequired={false}
                                  />

                                </Grid>

                              </Grid>
                            </Grid>

                            <Grid item xs={12} lg={12} xl={12} mt={1.5} >
                              <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderColor: 'divider',
                                borderRadius: 2,
                                color: 'text.secondary', '& svg': { m: 1, },
                              }} >
                                <Grid container spacing={0}>
                                  <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                                    <Typography variant="h5" mb={0.5}>Notes </Typography>
                                    <Grid item xs={12} lg={12} xl={10.5}>
                                      <TextField
                                        id="outlined-multiline-static"
                                        value={customerNotes}
                                        onChange={(e) => setCustomerNotes(e.target.value)}
                                        // placeholder="Enter the notes , will appear the issue indent."
                                        color="secondary"
                                        multiline
                                        rows={4}
                                        fullWidth
                                        variant="outlined"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                              <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                  <Tooltip title="Tax Collected at Source" arrow>
                                    <Typography
                                      variant="h6"
                                      fontSize={14}
                                      marginTop={0}
                                      textAlign="left"
                                      sx={{ cursor: 'help' }}
                                    >
                                      TCS Applicable
                                    </Typography>
                                  </Tooltip>

                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1.5}>
                                  <FormControlLabel
                                    control={<Switch checked={checkedTcsApplicable} color="secondary"
                                      onChange={handleChangeTcsApplicable} />}
                                    label={checkedTcsApplicable ? "On" : "Off"}
                                  />


                                </Grid>

                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1.3} display="flex-start" justifyContent="center">
                                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    FY Sale Value :
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={3.6} lg={2} xl={1.5}>
                                  <TextField
                                    value={fysalevalue}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
                                        setFysalevalue(val);
                                      }
                                    }}
                                    type="number"
                                    fullWidth
                                    size="small"
                                    color="secondary"
                                    variant="outlined"
                                    inputProps={{
                                      style: { textAlign: "right" }, // 👈 align text to the right
                                    }}
                                  />






                                </Grid>

                              </Grid>
                            </Grid>





                          </Grid>
                        </Box>
                      </TabPanel>

                      <TabPanel value={value} index={1} dir={theme.direction}>
                        <Box>
                          <Grid container spacing={1}>
                            <Grid item lg={6} xl={6}>
                              <Grid container>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                  <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h5" fontWeight={'bold'} textAlign="left" >
                                        Billing Address
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      {/* <Button variant="contained" sx={{ textTransform: "none", backgroundColor: colors.blueAccent[600] }}> Copy Billing Address</Button> */}
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Pin Code <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <TextField color="secondary" value={pincode} fullWidth size="small" label="" variant="outlined" onChange={(e) => setPincode(e.target.value)} />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >

                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Address <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <TextField
                                        required
                                        value={billingAddressLine1}
                                        onChange={(e) => setBillingAddressLine1(e.target.value)}
                                        fullWidth
                                        color="secondary"
                                        id="outlined-multiline-static"
                                        label="Address"
                                        multiline
                                        rows={2}
                                        defaultValue=""
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>




                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Country <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <Autocomplete
                                        fullWidth
                                        value={selectedCountry}
                                        onChange={handleCountryChange}
                                        size="small"
                                        options={country}
                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        State <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <Autocomplete
                                        fullWidth
                                        value={selectedState}
                                        onChange={handleStateChange}
                                        size="small"
                                        options={state}
                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />

                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        City <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <Autocomplete
                                        fullWidth
                                        value={selectedCity}
                                        onChange={handleCityChange}
                                        size="small"
                                        options={city}
                                        getOptionLabel={(option) => `${option.description}`}
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />

                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Area
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>


                                      <TextField color="secondary" value={billingarea} onChange={(e) => setBillingArea(e.target.value)}
                                        fullWidth size="small" label="" variant="outlined" />

                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Contact Person <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <TextField required color="secondary" value={billingcontactperson} onChange={(e) => setBillingContactPerson(e.target.value)}
                                        fullWidth size="small" label="" variant="outlined" />

                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Phone
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>


                                      <TextField
                                        value={phoneNumber}
                                        color="secondary"
                                        onChange={(e) => {
                                          const input = e.target.value;
                                          if (/^\d*$/.test(input) && input.length <= 10) {
                                            setPhoneNumber(input);
                                          }
                                        }}
                                        fullWidth
                                        size="small"
                                        type="tel"
                                        label="Phone Number 1"
                                        required
                                        variant="outlined"
                                        error={phoneNumber !== '' && !/^[0-9]{10}$/.test(phoneNumber)}
                                        helperText={
                                          phoneNumber !== '' && !/^[0-9]{10}$/.test(phoneNumber)
                                            ? 'Enter a valid 10-digit phone number'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <PhoneIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />


                                    </Grid>


                                    <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>

                                      <TextField
                                        value={phoneNumber2}
                                        color="secondary"
                                        onChange={(e) => {
                                          const input = e.target.value;
                                          if (/^\d*$/.test(input) && input.length <= 10) {
                                            setPhoneNumber2(input);
                                          }
                                        }}
                                        fullWidth
                                        size="small"
                                        type="tel"
                                        label="Phone Number 2"

                                        variant="outlined"
                                        error={phoneNumber2 !== '' && !/^[0-9]{10}$/.test(phoneNumber2)}
                                        helperText={
                                          phoneNumber2 !== '' && !/^[0-9]{10}$/.test(phoneNumber2)
                                            ? 'Enter a valid 10-digit phone number'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <PhoneIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Email 1
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      {/* <TextField value={faxNumber} onChange={(e) => setFaxNumber(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}
                                      <TextField
                                        color="secondary"
                                        value={faxNumber}
                                        onChange={(e) => setFaxNumber(e.target.value.toLowerCase())}
                                        type="email"
                                        fullWidth
                                        size="small"
                                        label="Email Address 1"


                                        variant="outlined"
                                        error={faxNumber !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(faxNumber)}
                                        helperText={
                                          faxNumber !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(faxNumber)
                                            ? 'Invalid email format'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <Email />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Email 2
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      {/* <TextField value={faxNumber} onChange={(e) => setFaxNumber(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}
                                      <TextField
                                        value={email2}
                                        color="secondary"
                                        onChange={(e) => setEmail2(e.target.value.toLowerCase())}
                                        type="email"
                                        fullWidth
                                        size="small"
                                        label="Email Address 2"

                                        variant="outlined"
                                        error={email2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email2)}
                                        helperText={
                                          email2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email2)
                                            ? 'Invalid email format'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <Email />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                              </Grid>
                            </Grid>


                            <Grid item lg={6} xl={6}>
                              <Grid container>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                      <Typography variant="h5" style={{ fontWeight: 550 }} >
                                        Shipping Address (<span fontSize='8px' style={{ color: 'lightblue' }}>
                                          <IconButton onClick={handleCopyBillingToShipping} style={{ borderRadius: '0px', marginRight: '0px' }}>
                                            <ArrowDownwardIcon style={{ color: "#1976d2", fontSize: '20px' }} />
                                            <Typography variant="button" fontSize={'14px'} style={{ fontWeight: 'bold', fontStyle: 'italic', textTransform: 'none', color: '#1976d2' }}> Copy billing address</Typography>
                                          </IconButton>
                                        </span>)
                                        (<span fontSize='8px' style={{ color: 'red' }}>
                                          <IconButton onClick={handleCopyBillingToShipping} style={{ borderRadius: '0px', marginRight: '0px' }}>
                                            {/* <ArrowDownwardIcon style={{ color: "#1976d2", fontSize: '20px' }} /> */}
                                            <Typography variant="button" fontSize={'14px'} style={{ fontWeight: 'bold', fontStyle: 'italic', textTransform: 'none', color: '#1976d2' }}> Primary</Typography>
                                          </IconButton>
                                        </span>)
                                      </Typography>
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Pin Code <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <TextField color="secondary" value={shippingPincode} onChange={(e) => setShippingPincode(e.target.value)} fullWidth size="small" label="" variant="outlined" />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Address <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <TextField
                                        required
                                        value={shippingAddressLine1}
                                        onChange={(e) => setShipingAddressLine1(e.target.value)}
                                        fullWidth
                                        id="outlined-multiline-static"
                                        label="Address"
                                        multiline
                                        color="secondary"
                                        rows={2}
                                        defaultValue=""
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Country <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <Autocomplete
                                        fullWidth
                                        value={selectedBillingCountry}
                                        onChange={handleBillingCountryChange}
                                        size="small"
                                        options={billingCountry}
                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        State <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <Autocomplete
                                        fullWidth
                                        value={selectedBillingState}
                                        onChange={handleBillingStateChange}
                                        size="small"
                                        options={billingState}
                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        City <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      <Autocomplete
                                        fullWidth
                                        value={selectedBillingCity}
                                        onChange={handleBillingCityChange}
                                        size="small"
                                        options={billingCity}
                                        getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                        renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Area
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>



                                      <TextField color="secondary" value={shippingarea} onChange={(e) => setShippingArea(e.target.value)}
                                        fullWidth size="small" label="" variant="outlined" />

                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Contact Person <span style={{ color: 'red' }}>*</span>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <TextField required color="secondary" value={shippingcontactperson} onChange={(e) => setShippingContactPerson(e.target.value)}
                                        fullWidth size="small" label="" variant="outlined" />

                                    </Grid>

                                  </Grid>
                                </Grid>




                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Phone
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>

                                      <TextField
                                        value={shippingPhoneNumber}
                                        color="secondary"
                                        onChange={(e) => {
                                          const input = e.target.value;
                                          if (/^\d*$/.test(input) && input.length <= 10) {
                                            setShippingPhoneNumber(input);
                                          }
                                        }}
                                        fullWidth
                                        size="small"
                                        type="tel"
                                        label="Phone Number 1"
                                        required
                                        variant="outlined"
                                        error={shippingPhoneNumber !== '' && !/^[0-9]{10}$/.test(shippingPhoneNumber)}
                                        helperText={
                                          shippingPhoneNumber !== '' && !/^[0-9]{10}$/.test(shippingPhoneNumber)
                                            ? 'Enter a valid 10-digit phone number'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <PhoneIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>

                                      <TextField
                                        value={shippingPhoneNumber2}
                                        color="secondary"
                                        onChange={(e) => {
                                          const input = e.target.value;
                                          if (/^\d*$/.test(input) && input.length <= 10) {
                                            setShippingPhoneNumber2(input);
                                          }
                                        }}
                                        fullWidth
                                        size="small"
                                        type="tel"
                                        label="Phone Number 2"

                                        variant="outlined"
                                        error={shippingPhoneNumber2 !== '' && !/^[0-9]{10}$/.test(shippingPhoneNumber2)}
                                        helperText={
                                          shippingPhoneNumber2 !== '' && !/^[0-9]{10}$/.test(shippingPhoneNumber2)
                                            ? 'Enter a valid 10-digit phone number'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <PhoneIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Email 1
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                      {/* <TextField value={shippingfaxNumber} onChange={(e) => setShippingFaxNumber(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}


                                      <TextField
                                        value={shippingfaxNumber}
                                        color="secondary"
                                        onChange={(e) => setShippingFaxNumber(e.target.value.toLowerCase())}
                                        type="email"
                                        fullWidth
                                        size="small"
                                        label="Email Address 1"

                                        variant="outlined"
                                        error={shippingfaxNumber !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(shippingfaxNumber)}
                                        helperText={
                                          shippingfaxNumber !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(shippingfaxNumber)
                                            ? 'Invalid email format'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <Email />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />


                                    </Grid>

                                  </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                    <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                      <Typography variant="h6" fontSize={14} textAlign="left" >
                                        Email 2
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                      <TextField
                                        value={shippingEmail2}
                                        color="secondary"
                                        onChange={(e) => setShippingEmail2(e.target.value.toLowerCase())}
                                        type="email"
                                        fullWidth
                                        size="small"
                                        label="Email Address 2"

                                        variant="outlined"
                                        error={shippingEmail2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(shippingEmail2)}
                                        helperText={
                                          shippingEmail2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(shippingEmail2)
                                            ? 'Invalid email format'
                                            : ''
                                        }
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <Email />
                                            </InputAdornment>
                                          ),
                                        }}
                                      />


                                    </Grid>

                                  </Grid>
                                </Grid>

                              </Grid>
                            </Grid>




                          </Grid>



                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                            <Divider />
                          </Grid>
                          <Grid mt={2} container>

                            <Grid item lg={6} xl={6}>
                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={11} md={3.8} lg={12} xl={8}>
                                    <Typography variant="h5" style={{ fontWeight: 550 }} >
                                      Correspondance Address (<span fontSize='8px' style={{ color: 'lightblue' }}>
                                        <IconButton onClick={handleCopyBillingToCorrespondenceAddress} style={{ borderRadius: '0px', marginRight: '0px' }}>
                                          <ArrowDownwardIcon style={{ color: "#1976d2", fontSize: '20px' }} />
                                          <Typography variant="button" fontSize={'14px'} style={{ fontWeight: 'bold', fontStyle: 'italic', textTransform: 'none', color: '#1976d2' }}> Copy billing address</Typography>
                                        </IconButton>
                                      </span>)

                                    </Typography>
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                      Pin Code <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                    <TextField color="secondary" value={correspondencePincode} onChange={(e) => setCorrespondencePincode(e.target.value)} fullWidth size="small" label="" variant="outlined" />
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                      Address <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                    <TextField
                                      required
                                      value={correspondenceAddressLine1}
                                      color="secondary"
                                      onChange={(e) => setCorrespondenceAddressLine1(e.target.value)}
                                      fullWidth
                                      id="outlined-multiline-static"
                                      label="Address"
                                      multiline
                                      rows={2}
                                      defaultValue=""
                                    />
                                  </Grid>

                                </Grid>
                              </Grid>


                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                      Country <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                    <Autocomplete
                                      fullWidth
                                      value={selectedCorrespondenceCountry}
                                      onChange={handleCorrespondenceCountryChange}
                                      size="small"
                                      options={correspondenceCountry}
                                      getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                      renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                    />
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                      State <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                    <Autocomplete
                                      fullWidth
                                      value={selectedCorrespondanceState}
                                      onChange={handlecorrespondenceStateChange}
                                      size="small"
                                      options={correspondenceState}
                                      getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                      renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                    />
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                      City <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                    <Autocomplete
                                      fullWidth
                                      value={selectedCorrespondenceCity}
                                      onChange={handleCorrespondenceCityChange}
                                      size="small"
                                      options={correspondenceCity}
                                      getOptionLabel={(option) => `${option.description}`} // Assuming lot numbers are strings label="Child Roll" 
                                      renderInput={(params) => <TextField color="secondary" {...params} variant="outlined" />}
                                    />
                                  </Grid>

                                </Grid>
                              </Grid>

                            </Grid>


                            <Grid item lg={6} xl={6}>



                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                      Area
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>



                                    <TextField color="secondary" value={correspondenceArea} onChange={(e) => setCorrespondenceArea(e.target.value)}
                                      fullWidth size="small" label="" variant="outlined" />

                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                      Contact Person <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                    <TextField required color="secondary" value={correspondencecontactperson} onChange={(e) => setCorrespondenceContactPerson(e.target.value)}
                                      fullWidth size="small" label="" variant="outlined" />

                                  </Grid>

                                </Grid>
                              </Grid>




                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                      Phone
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>

                                    <TextField
                                      color="secondary"
                                      value={correspondancePhoneNumber}
                                      onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d*$/.test(input) && input.length <= 10) {
                                          setCorrespondancePhoneNumber(input);
                                        }
                                      }}
                                      fullWidth
                                      size="small"
                                      type="tel"
                                      label="Phone Number 1"
                                      required
                                      variant="outlined"
                                      error={correspondancePhoneNumber !== '' && !/^[0-9]{10}$/.test(correspondancePhoneNumber)}
                                      helperText={
                                        correspondancePhoneNumber !== '' && !/^[0-9]{10}$/.test(correspondancePhoneNumber)
                                          ? 'Enter a valid 10-digit phone number'
                                          : ''
                                      }
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <PhoneIcon />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={3.5} xl={4}>

                                    <TextField
                                      color="secondary"
                                      value={correspondancePhoneNumber2}
                                      onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d*$/.test(input) && input.length <= 10) {
                                          setCorrespondancePhoneNumber2(input);
                                        }
                                      }}
                                      fullWidth
                                      size="small"
                                      type="tel"
                                      label="Phone Number 2"

                                      variant="outlined"
                                      error={correspondancePhoneNumber2 !== '' && !/^[0-9]{10}$/.test(correspondancePhoneNumber2)}
                                      helperText={
                                        correspondancePhoneNumber2 !== '' && !/^[0-9]{10}$/.test(correspondancePhoneNumber2)
                                          ? 'Enter a valid 10-digit phone number'
                                          : ''
                                      }
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <PhoneIcon />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                      Email 1
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                    {/* <TextField value={shippingfaxNumber} onChange={(e) => setShippingFaxNumber(e.target.value)} fullWidth size="small" label="" variant="outlined" /> */}


                                    <TextField
                                      color="secondary"
                                      value={correspondanceEmail1}
                                      onChange={(e) => setCorrespondanceEmail1(e.target.value.toLowerCase())}
                                      type="email"
                                      fullWidth
                                      size="small"
                                      label="Email Address 1"

                                      variant="outlined"
                                      error={correspondanceEmail1 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correspondanceEmail1)}
                                      helperText={
                                        correspondanceEmail1 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correspondanceEmail1)
                                          ? 'Invalid email format'
                                          : ''
                                      }
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <Email />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />


                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container padding="10px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} textAlign="left" >
                                      Email 2
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                    <TextField
                                      color="secondary"
                                      value={correspondanceEmail2}
                                      onChange={(e) => setCorrespondanceEmail2(e.target.value.toLowerCase())}
                                      type="email"
                                      fullWidth
                                      size="small"
                                      label="Email Address 2"

                                      variant="outlined"
                                      error={correspondanceEmail2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correspondanceEmail2)}
                                      helperText={
                                        correspondanceEmail2 !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correspondanceEmail2)
                                          ? 'Invalid email format'
                                          : ''
                                      }
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <Email />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />


                                  </Grid>

                                </Grid>
                              </Grid>

                            </Grid>

                          </Grid>










                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                            <Divider />
                          </Grid>
                          {shippingAddress.map((Shipto, index) => (
                            <Grid container spacing={1}>
                              <Grid item lg={6} xl={6}>
                                <Box>

                                  <Grid container key={index}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                      <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                        <Grid item xs={12} sm={12} md={1.6} lg={8} xl={8}>
                                          <Typography variant="h6" fontSize={16} fontWeight={'bold'} textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
                                            Shipping Address {index + 1} (
                                            <span>
                                              <Typography variant="button" fontSize={'15px'} style={{ fontWeight: 'bold', fontStyle: 'italic', textTransform: 'none', color: '#38e85ee5' }}> Secondary </Typography>
                                            </span>

                                            )
                                          </Typography>
                                        </Grid>


                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                          <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                              <Typography variant="h6" fontSize={14} textAlign="left">
                                                Pin Code
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                              <TextField
                                                fullWidth
                                                color="secondary"
                                                size="small"
                                                name="pincode"
                                                type="number"
                                                value={Shipto.pincode}
                                                onChange={(e) => handleShippingInputChange(index, e)}
                                                label=""
                                                variant="outlined"
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>


                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                          <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                              <Typography variant="h6" fontSize={14} textAlign="left">
                                                Address
                                              </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                              <TextField
                                                value={Shipto.shippingAddressLine1}
                                                onChange={(e) => handleShippingInputChange(index, e)}
                                                fullWidth
                                                color="secondary"
                                                name='shippingAddressLine1'
                                                id="outlined-multiline-static"
                                                label="shippingAddressLine1"
                                                multiline
                                                rows={2}
                                                defaultValue=""
                                              />
                                            </Grid>

                                          </Grid>
                                        </Grid>




                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                          <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                              <Typography variant="h6" fontSize={14} textAlign="left" required>
                                                Country
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>

                                              <TextField
                                                size="small"
                                                color="secondary"
                                                value={Shipto.country}
                                                onChange={(e) => handleShippingInputChange(index, e)}
                                                fullWidth
                                                id="outlined-multiline-static"
                                                name="country"

                                                defaultValue=""
                                              />




                                            </Grid>
                                          </Grid>
                                        </Grid>


                                      </Grid>
                                    </Grid>
                                  </Grid>

                                </Box>
                              </Grid>



                              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                                <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                  <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5}>
                                    <Typography variant="h6" fontSize={16} textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>

                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                      <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                          State
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                        <TextField
                                          size="small"
                                          color="secondary"
                                          value={Shipto.state}
                                          onChange={(e) => handleShippingInputChange(index, e)}
                                          fullWidth
                                          id="outlined-multiline-static"
                                          name="state"
                                          // multiline
                                          // rows={2}
                                          defaultValue=""
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                      <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                          City
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>
                                        <TextField
                                          size="small"
                                          color="secondary"
                                          value={Shipto.city}
                                          onChange={(e) => handleShippingInputChange(index, e)}
                                          fullWidth
                                          id="outlined-multiline-static"
                                          name="city"
                                          // multiline
                                          // rows={2}
                                          defaultValue=""
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                      <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                          Contact
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>


                                        <TextField
                                          value={Shipto.contact}
                                          color="secondary"
                                          onChange={(e) => {
                                            const input = e.target.value;
                                            if (/^\d*$/.test(input) && input.length <= 10) {
                                              handleShippingInputChange(index, e);
                                            }
                                          }}
                                          fullWidth
                                          size="small"
                                          type="tel"
                                          label="Work Phone"
                                          name="contact"

                                          variant="outlined"
                                          error={Shipto.contact !== '' && !/^[0-9]{10}$/.test(Shipto.contact)}
                                          helperText={
                                            Shipto.contact !== '' && !/^[0-9]{10}$/.test(Shipto.contact)
                                              ? 'Enter a valid 10-digit phone number'
                                              : ''
                                          }
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <PhoneIcon />
                                              </InputAdornment>
                                            ),
                                          }}
                                        />

                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                      <Grid item xs={12} sm={12} md={1.6} lg={3} xl={2.5} display="flex-start" justifyContent="center">
                                        <Typography variant="h6" fontSize={14} textAlign="left">
                                          Email
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={11} md={3.8} lg={7} xl={8}>


                                        <TextField
                                          value={Shipto?.email || ''}
                                          color="secondary"
                                          onChange={(e) => handleShippingInputChange(index, e)}
                                          type="email"
                                          name="email"
                                          fullWidth
                                          size="small"
                                          label="Email Address"

                                          variant="outlined"
                                          error={
                                            Shipto?.email &&
                                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Shipto.email)
                                          }
                                          helperText={
                                            Shipto?.email &&
                                              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Shipto.email)
                                              ? 'Invalid email format'
                                              : ''
                                          }
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <Email />
                                              </InputAdornment>
                                            ),
                                          }}
                                        />

                                      </Grid>
                                      {index > 0 && (
                                        <Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
                                          <IconButton onClick={() => removeShippingDetail(index)} color="secondary">
                                            <DeleteIcon />
                                          </IconButton>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>



                                </Grid>
                              </Grid>

                              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                <Divider />
                              </Grid>
                            </Grid>
                          ))}

                          <Button
                            size='small'
                            sx={{ marginTop: "10px", textTransform: "none" }}
                            onClick={addShippingDetail}
                            variant="standard"
                            color="primary"
                            startIcon={<AddIcon />}
                          >
                            Add Secondary Shipping Address
                          </Button>
                        </Box>
                      </TabPanel>

                      <TabPanel value={value} index={2} dir={theme.direction}>
                        <Box>
                          <ContactTable contacts={contacts} setContacts={setContacts} />
                        </Box>
                      </TabPanel>

                      <TabPanel value={value} index={3} dir={theme.direction}>
                        <Box>
                          {bankDetails.map((bankDetail, index) => (


                            <BankDetailsForm
                              key={index}
                              index={index}
                              bankDetail={bankDetail}
                              bankAccounts={bankAccounts}
                              showPassword={showPassword}
                              accountMismatch={accountMismatch}
                              handleInputChange={handleInputChange}
                              handleAutocompleteChange={handleAutocompleteChange}
                              handleClickShowPassword={handleClickShowPassword}
                              handleMouseDownPassword={handleMouseDownPassword}
                              handleBankLetterInputChange={handleBankLetterInputChange}
                              handleDownloadBankLetter={handleDownloadBankLetter}
                              removeBankDetail={removeBankDetail}
                              handleChequeInputChange={handleChequeInputChange}
                              handleRTGSInputChange={handleRTGSInputChange}
                              setAccountMismatch={setAccountMismatch}
                              handleOpenModal={handleOpenModal}
                            />



                          ))}

                          <Button
                            size='small'
                            sx={{ marginTop: "10px", textTransform: "none" }}
                            onClick={addBankDetail}
                            variant="standard"
                            color="primary"
                            startIcon={<AddIcon />}
                          >
                            Add Bank Detail
                          </Button>


                        </Box>
                      </TabPanel>


                    </SwipeableViews>
                  </Box>

                </Grid>

              </Grid>
            </Grid>

          </Grid>
        </ResponsiveBox>


        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

              <Toolbar>
                <Button type="submit" disabled={saveButtonDisabled} size="small" variant="contained" color="secondary" startIcon={<Save />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save</Button>
                {/* <Button size="small" variant="standard" startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button> */}
              </Toolbar>
            </Box>
          </Grid>
        </Grid>


      </form>

      {/* Render modal if isModalOpen is true */}
      {
        isModalOpen && < AddTDS onClose={handleCloseModal} open={isModalOpen} />
      }

      {
        isPaymentModalOpen && <AddPaymentTerms onClose={handlePaymentTermsCloseModal} open={isPaymentModalOpen} />
      }

      {
        isCreditTermsModalOpen && <AddCreditTerms onClose={handleCreditTermsCloseModal} open={isCreditTermsModalOpen} />
      }

      {
        isModalAccountOpen && <AddBankAccount onClose={handleBankAccountCloseModal} open={isModalAccountOpen} />
      }

      {
        isModalPartyTypeOpen && <AddPartyType onClose={handlePartyTypeCloseModal} open={isModalPartyTypeOpen} />
      }
    </Box>

  </>)
}
export default AddNewVendor;